import React, { useRef } from 'react';

import styled from 'styled-components';
import { ControlLabel, Glyphicon } from 'react-bootstrap';
import Select from 'react-select';

import ActivityFormFieldWrapper from '../ActivityFormFieldWrapper';

import ActivityFormMultiSelectorSelected from './ActivityFormMultiSelectorSelected';

const StyledWrapper = styled(ActivityFormFieldWrapper)`
  display: ${props => props.display || 'flex'};
  margin-top: 15px;
`;

const StyledContentWrapper = styled.div`
  width: 80%;
  h4 {
    font-weight: 400;
    margin: 5px 0;
    font-size: 16px;
  }
`;

const StyledItem = styled.div`
  background-color: #ffffff;
  padding: 15px;
  box-shadow: 0 2px 7px 0 rgb(0 0 0 / 10%);
  border: solid 1px #ededed;
  span {
    display: inline-block;
    background: #e4e5e7;
    color: #6d7175;
    margin-right: 10px;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 10px;
    button {
      outline: none;
      border: none;
      background: #e4e5e7;
      margin: 0;
      padding: 0;
      margin-left: 10px;
    }
  }
`;

type Props = {
  label: string;
  selectedItems: string[];
  options: string[];
  onItemClick(tag: string): void;
  display?: boolean;
  labelStyle: React.CSSProperties;
  caption: string;
};

const ActivityFormMultiSelector = ({
  label,
  selectedItems,
  options,
  onItemClick,
  display,
  labelStyle,
  caption,
}: Props) => {
  const selectInputRef = useRef<Select>(null);

  const onClear = () => {
    const node = selectInputRef.current;
    if (!node) {
      return;
    }
    node.select.clearValue();
  };
  return (
    <StyledWrapper label={label} display={display}>
      <ControlLabel style={labelStyle}>{label}:</ControlLabel>
      <StyledContentWrapper>
        <Select
          styles={{
            control: styles => ({
              ...styles,
              width: '50%',
              marginBottom: '20px',
              marginTop: '30px',
            }),
          }}
          components={{
            DropdownIndicator: () => (
              <Glyphicon
                style={{ color: '#c4c4c4', paddingRight: '10px' }}
                glyph='chevron-down'
              />
            ),
            IndicatorSeparator: () => null,
            ClearIndicator: () => null,
          }}
          placeholder={'Start typing to select'}
          isSearchable
          options={options.map(item => ({ value: item, label: item }))}
          onChange={item => {
            const { value } = item ?? { value: undefined };
            if (value) {
              onItemClick(value);
              onClear();
            }
          }}
          value={null}
          isClearable
        />
        <ActivityFormMultiSelectorSelected
          caption={caption}
          selectedItems={selectedItems}
          onItemClick={onItemClick}
          StyledItem={StyledItem}
        />
      </StyledContentWrapper>
    </StyledWrapper>
  );
};

export default React.memo(ActivityFormMultiSelector);
